import { Patient } from "@/types/users";

import UserState from "./constants";

export default {
  setTimeZone(state: UserState, payload: string) {
    state.timeZone = payload;
  },
  setPatient(state: UserState, payload: Patient) {
    state.patient = payload;
  },
};
